import React from "react";
import ReactHtmlParser from "react-html-parser";
export default function PromiseSection({
  subtitle,
  title,
  description,
  isSmallWidth = false,
  leftIcon,
  rightIcon,
}) {
  return (
    <section  className="promise-section position-relative py-5">
      <div style={isSmallWidth ? {width: "60%"} : {}}  className="container text-center position-relative">
        <h3 className="text-success FS40FW600 mb-0">{subtitle}</h3>

        <h3 className="main-title FS40FW600">{title}</h3>

        <p style={{color:"#383838"}} className="promise-description plus-sans FS18FW400 fw-500">{ReactHtmlParser(description)}</p>
      </div>
    </section>
  );
}
